import {call, put, takeEvery} from 'redux-saga/effects'
import {defineTypes} from '../helpers'
import {reduxFetch} from '../http/reduxFetch'
import ProductsEndpoint from '../persistence/ProductsEndpoint'

const productOptionsTypes = {...defineTypes('PRODUCT_OPTIONS')}

export const initialState = {
  product_options_0: [],
  product_options_1: [],
  product_options_2: [],
  product_options_3: [],
  product_options_4: []
}
export const actions = {
  requestProducts(kegNumber, company_id) {
    return {type: productOptionsTypes.REQUEST, keg_number: kegNumber, company_id: company_id}
  }
}
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case productOptionsTypes.REQUEST:
      return {...state, started: true, loading: true}
    case productOptionsTypes.FAILURE:
      return {...state, loading: false}
    case productOptionsTypes.SUCCESS:
      return {...state, [`product_options_${action.keg_number}`]: action.data, loading: false, started: false}
    default:
      return state
  }
}

export const selectors = {
  product: (store, keg_number) => store.product_options[`product_options_${keg_number}`],

  productById: (store, id, keg_number) => store.product_options[`product_options_${keg_number}`] && store.product_options[`product_options_${keg_number}`].find(product => {
    return product.id === id
  })
}

export function* productOptionsSaga(action) {
  try {
    const product_options = yield call(reduxFetch, ProductsEndpoint.reservation_index(action.company_id))
    yield put({type: 'KEG_SIZE_OPTIONS/REQUEST', company_id: action.company_id})
    console.log(product_options)
    yield put({type: productOptionsTypes.SUCCESS, data: product_options['data'], keg_number: action.keg_number})
  } catch (error) {
    console.log(error)
    yield put({type: productOptionsTypes.FAILURE, error})
  }
}

export function* rootSaga() {
  yield takeEvery(productOptionsTypes.REQUEST, productOptionsSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/product_options.js